import React, { useMemo, useState } from 'react';
import { WTitle, CTitle } from '../../components/Widget';
import SharedLeftBottom from '../../../../../../assets/2025/topic1400/shared_left_bottom.png';

import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
// eslint-disable-next-line no-duplicate-imports
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import section3_3_2 from '../../../../../../assets/2025/topic1400/section3_3_2.png';
import section3_3_2_m from '../../../../../../assets/2025/topic1400/section3_3_2_m.png';
import section3_3_1 from '../../../../../../assets/2025/topic1400/section3_3_1.png';

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  // const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({
    clickSlide: 2,
    state1: false,
    active: 0,
  });
  React.useEffect(() => {
    if (state.state1) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1400-section2-1');
      // updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [state.state1]);
  return (
    <div className="topic-section-3">
      <WTitle title={paragraphsSettings?.title} />
      <CTitle title={paragraphsSettings?.fileTitle} />
      <div id="2025-topic1400-section2-1" className="share">
        <img src={section3_3_1} alt="" className="l1 pc_hide" />
        <div className="l2">
          <div className="left" style={{ display: state.state1 ? '' : 'none' }}>
            <p
              className="p2"
              dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l1 }}
            />
          </div>
          <div
            className="right"
            onClick={() => setState({ ...state, state1: true })}
          >
            <span className="p1">{paragraphsSettings?.l2}</span>
            <img
              src={ArrowImg}
              alt=""
              style={{ display: state.state1 ? 'none' : '' }}
              className="arrow_icon"
            />
          </div>
          <img src={section3_3_2} alt="" className="pc_hide" />
          <img src={section3_3_2_m} alt="" className="mobile_show img_pic" />
        </div>
      </div>
      <CTitle title={paragraphsSettings?.fileTitle1} />
      <div className="file-subtitle">{paragraphsSettings?.fileSubtitle}</div>
      <div className={`file-content file-content${state.active}`}>
        <img src={SharedLeftBottom} alt="" />
        <div className="word-l0 word-l1">
          {paragraphsSettings?.shareList?.[state.active]?.l1}
          <h3>01</h3>
        </div>
        <div className="word-l0 word-l2">
          {paragraphsSettings?.shareList?.[state.active]?.l2}
          <h3>02</h3>
        </div>
        <div className="word-l0 word-l3">
          <h3>03</h3>
          {paragraphsSettings?.shareList?.[state.active]?.l3}
        </div>
        <div className="file-content-center">
          <div
            className="center-word"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.shareList?.[state.active]?.l0,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Section2;
